<div class="flex gap-3">
  <lib-button size="sm" variant="outline" startIcon="long-arrow-left" (btnClick)="moveRange(false)" class="max-[310px]:hidden shrink-0"></lib-button>
  <lib-button size="sm" variant="outline" (btnClick)="openDatePicker()" startIcon="calendar-simple" class="flex-1" className="capitalize">
    @if(isSameDay(dateSelection().startDate, dateSelection().endDate)) {
      @if (isToday(dateSelection().startDate)) {
        Hoy {{ dateSelection().startDate | date:'dd MMM':'' :'es' }}
      } @else {
        {{ dateSelection().startDate | date:'dd MMM':'' :'es' }}
      }
    } @else {
      {{ dateSelection().startDate | date:'dd MMM': '' : 'es' }} - {{ dateSelection().endDate | date:'dd MMM': '' : 'es' }} 
    }
  </lib-button>
  <lib-button size="sm" variant="outline" startIcon="long-arrow-right" (btnClick)="moveRange(true)" class="max-[310px]:hidden shrink-0"></lib-button>
</div>

<lib-modal-date-picker 
  [(isOpen)]="isDatePickerOpen"
  [selection]="dateSelection()"
  (confirmed)="onConfirmed($event)"
  (closed)="onClosed()"
  [maxDays]="maxDays()"
  >
</lib-modal-date-picker>